import React from 'react'

const EFFECTIVE = 'June 29, 2026'

export default function Privacy() {
  return (
    <section className="page">
      <div className="container">
        <h1>Privacy Policy</h1>
        <p className="updated">Last updated: {EFFECTIVE}</p>

        <p>
          Heard is built to be private by default. This policy explains what the App does and does not
          collect. Heard is provided by Alana .sh (“we”, “us”).
        </p>

        <h2>The short version</h2>
        <p>
          Heard does not require an account, and we do not collect, store, or sell your personal
          information. Your reading happens on your device.
        </p>

        <h2>On-device processing</h2>
        <p>
          Text-to-speech narration is generated entirely on your device. The text of the books you read
          and the audio that’s produced are never sent to us or to any third-party server. Books you
          import stay on your device.
        </p>

        <h2>Information we don’t collect</h2>
        <ul>
          <li>No name, email, or account is required to use the App.</li>
          <li>No reading history, listening activity, or library contents are transmitted to us.</li>
          <li>No advertising identifiers, and no third-party analytics or ad SDKs.</li>
        </ul>

        <h2>Purchases</h2>
        <p>
          If you subscribe to Heard Pro, the purchase is processed by Apple, and subscription status is
          managed through our payments provider, RevenueCat. To validate your subscription, RevenueCat
          receives a randomly generated, app-specific identifier and your App Store purchase receipt. We
          do not receive your name or payment-card details. See{' '}
          <a href="https://www.revenuecat.com/privacy" target="_blank" rel="noreferrer">RevenueCat’s privacy policy</a>{' '}
          and{' '}
          <a href="https://www.apple.com/legal/privacy/" target="_blank" rel="noreferrer">Apple’s privacy policy</a>.
        </p>

        <h2>Local storage</h2>
        <p>
          Settings (such as your chosen voice, theme, and font), your reading position, and any imported
          books are stored locally on your device. Deleting the App removes this data.
        </p>

        <h2>Children</h2>
        <p>
          Heard is not directed to children under 13 and does not knowingly collect information from
          them. Because the App collects no personal information, it is suitable for general audiences.
        </p>

        <h2>Changes</h2>
        <p>
          We may update this policy from time to time. Material changes will be reflected by the “Last
          updated” date above.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about your privacy? Email hello [at] alana [dot] sh.
        </p>

        <p style={{ color: 'var(--muted)', fontSize: 13, marginTop: 40 }}>
          This document is a general template and not legal advice. Confirm it reflects your actual data
          practices before publishing.
        </p>
      </div>
    </section>
  )
}
